module.exports = __webpack_public_path__ + "img/tv-55.47f518f3.jpeg";